// Replace this with your actual API endpoint

 /* const apiUrl = "https://your-server.com/api/customer-data"; */

 const apiUrl = "https://app.vetmeds.ca/listpetprofiles.php";


document.addEventListener('DOMContentLoaded', function() 
{
  // Access the customer ID
  var customerId = window.Shopify.customer_id;

  if (customerId) {
    /////////// alert("Customer ID: " + customerId);
    console.log("Customer ID: " + customerId);
  } else {
    /////// alert('nnnnnnnaaaaaaaaaa');
    console.log("No customer logged in.");
  }
});


// Get the customer ID from Shopify Liquid variables
/////////// const shopifyCustomerId = "{{ customer.id }}"; // This will be rendered by Shopify Liquid
const shopifyCustomerId = window.Shopify.customer_id;
const detailsContainer = document.getElementById("custom-details");


fetch(`${apiUrl}?customer_id=${shopifyCustomerId}`)
  .then((response) => response.json())
  .then((data) => {
    console.log("API Response:", data);

    if (Array.isArray(data)) {
      
      if (detailsContainer) {
        var tableHTML = '';
      tableHTML = '<table><tr class="tabhead"><td width="11%">S. No.</td><td> Name</td><td width="9%"> Age</td><td width="22%"> Breed</td> <td> Color</td><td> Type</td><td width="13%"> Weight</td><td width="13%" align="left"> Actions</td></tr>'; // Clear existing content

        // Loop through the array and display each record
        for (let i = 0; i < data.length; i++) {
            tableHTML += '<tr class="tabbody"><td>' + (i + 1) + '</td><td><a href="?ui=viewpet&pid='+ data[i].id +'">' + data[i].pet_name + '</a></td><td>' + data[i].petage + '</td><td>' + data[i].pet_breed + '</td><td>' + data[i].pet_color +'</td><td>' + data[i].pettype + '</td><td>' + data[i].weight + ' ' + data[i].petweightunit + '</td><td> <a href="?ui=editpet&pid='+ data[i].id +'"><img title="Edit" src="https://cdn.shopify.com/s/files/1/0688/1388/1523/files/edit.png?v=1734695769" height="16"></a> | <a href="?ui=delttpet&pid='+ data[i].id +'" onclick="return confirm(\'Are you sure you want to delete this pet?\');"><img src="https://cdn.shopify.com/s/files/1/0688/1388/1523/files/delete-icon.png" titl="Delete" alt="Delete" height="15"></a> | <a href="?ui=viewprescriptions&pid='+ data[i].id +'"><img title="View Available Prescriptions" src="https://cdn.shopify.com/s/files/1/0688/1388/1523/files/medical.png" height="15" ></a> </td></tr>';

        }

        tableHTML += '</table>';

        detailsContainer.innerHTML =  tableHTML; 
        

        
      }
    } else {
      detailsContainer.innerHTML =  'No data found';
      console.warn("Expected an array but got:", data);
    }
  })
  
  .catch((error) => {  detailsContainer.innerHTML =  'No data found';
    console.error("Error fetching customer data:", error);
  });